import styled from "styled-components";
import React from "react";
import { Tooltip } from "@plum-xoxo/admin-dsm";

const StyledRecipientButtonDiv = styled.div`
  background-color: ${(props) => props.theme.palette.base.c00};
  margin-top: auto;
  padding: 12px 0px;
  gap: 8px;
  border-top: 1px solid ${(props) => props.theme.palette.light.c300} }}
`;

const RecipientButtonDiv = (props) => {
  const { kybStatus, activeTab } = props;

  return (
    <StyledRecipientButtonDiv>
      {activeTab === 1 &&
      (kybStatus.kyb_status === 1 ||
        kybStatus.kyb_status === 3 ||
        kybStatus.kyb_status === 5) ? (
        <Tooltip
          placement="top"
          offset={[0, 5]}
          tooltip={
            <>
              Business verification is in process. You will <br />
              be able to send rewards after verification.
            </>
          }
        >
          <div className="d-flex gap-12">{props.children}</div>
        </Tooltip>
      ) : (
        <div className="d-flex gap-8">{props.children}</div>
      )}
    </StyledRecipientButtonDiv>
  );
};



export default RecipientButtonDiv;
